module.exports = __webpack_public_path__ + "static/media/verticalEndCap.b8f7e830.png";